export const PrivacyNotes = () => (
  <p className='privacy-notes caption'>
    For support and product improvement purposes your session may be recorded. For more information, please visit our
    <a target='_blank' href='https://www.yembo.ai/legal/privacy-policy' rel='noreferrer'>
      {' '}
      Privacy Policy
    </a>{' '}
    and
    <a target='_blank' href='https://logrocket.com/privacy/' rel='noreferrer'>
      {' '}
      LogRocket’s privacy policy
    </a>
    . This software is protected by{' '}
    <a target='_blank' href='https://www.yembo.ai/legal/patents' rel='noreferrer'>
      patents
    </a>
    . &copy; {new Date().getFullYear()} Yembo, Inc.
  </p>
);
